<template>
    <el-select
        v-model="modelValue"
        :value-key="valueKey"
        :clearable="clearable"
        :value="value"
        :disabled="disabled"
        multiple
        @change="change"
        @remove-tag="removeTag"
        :popper-append-to-body="false"
    >
        <el-option
            v-for="item in options"
            :key="item[valueField]"
            :label="item[labelField]"
            :value="item[valueField]"
            :disabled=item[disabledField]
        >
        </el-option>
    </el-select> <!-- @change="test" -->
</template>

<script>
export default {
    props: {
        value: {
            type: [Number, String, Array, Object],
            default: "",
        },
        valueKey: {
            type: String,
            default: "value",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
            default: () => [],
        },
        labelField: {
            type: String,
            default: "label",
        },
        valueField: {
            type: String,
            default: "value",
        },
        disabledField:{
            type: String,
            default: "disabled",
        },
        clearable:{
            type: Boolean,
            default: false,
        }
    },
    created(){
        console.log("options",this.options)
    },
    computed: {
        modelValue: {
            get({ value, $attrs }) {
               // if (!Array.isArray(value)) return [];
                return value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        test(event){
            console.log(event);
            console.log("value:"+this.value);
            console.log("valueKey:"+this.valueKey);
            console.log("disabled:"+this.disabled);
            console.log("options:"+this.options);
            console.log("labelField:"+this.labelField);
            console.log("valueField:"+this.valueField);
        },
        change(selectedvalue){
            this.$emit("confsitechange",selectedvalue)
        },
        removeTag(selectedvalue){
            this.$emit("removeTag",selectedvalue)
        }

    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner:focus {
    border-color: var(--main-color) !important;
}

// 让下拉选项中的文字换行
::v-deep .el-select-dropdown__item {
  white-space: normal !important;  // 允许换行
  word-wrap: break-word !important;  // 长单词换行
  word-break: break-all !important;  // 允许在任意字符间换行
  line-height: 1.4 !important;  // 调整行高
  padding: 10px 20px !important;  // 增加内边距，让多行文本更好看
  height: auto !important;  // 自动高度
  min-height: 34px !important;  // 最小高度
}

// 同时调整已选中的标签样式，让它们也能换行
::v-deep .el-select__tags-text {
  white-space: normal !important;
  word-break: break-all !important;
  display: inline-block !important;
  max-width: 150px !important;  // 限制最大宽度
}

::v-deep .el-tag {
  height: auto !important;
  white-space: normal !important;
  line-height: 1.4 !important;
  padding: 4px 8px !important;
  margin: 2px !important;
}

// 调整下拉框的宽度，防止内容被截断
::v-deep .el-select-dropdown {
  max-width: 500px !important;
  width: auto !important;
  min-width: 200px !important;
}

.option-item {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>